'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationHeader = undefined;

var _RegistrationHeader2 = require('./RegistrationHeader');

var _RegistrationHeader3 = _interopRequireDefault(_RegistrationHeader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RegistrationHeader = _RegistrationHeader3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationHeader/index.js
// module id = 1754
// module chunks = 0